// @flow

/**
 * Module dependencies.
 */

import { RetinaImage } from 'client/components/core/images';
import { colors, units } from 'client/styles';
import Layout from 'client/components/core/layout';
import RawHtml from 'react-raw-html';
import React from 'react';
import Text from 'client/components/core/type';

/**
 * `Props` type.
 */

type Props = {
  description: string,
  imgUrl: string,
  lead: string,
  title: string
};

/**
 * `TeamMember` component.
 */

function TeamMember(props: Props): React$Element<*> {
  const { description, imgUrl, lead, title } = props;

  return (
    <div>
      <Layout marginBottom={units(2)}>
        <RetinaImage
          baseWidth={'100px'}
          extension={'jpeg'}
          filename={imgUrl}
          maxWidth={'100px'}
          styles={'border-radius: 50%;'}
          title={title}
        />
      </Layout>

      <Text.H4
        color={colors.brandPrimary}
        marginBottom={units(0)}
      >
        {title}
      </Text.H4>

      <Layout
        marginBottom={units(0.5)}
        opacity={0.5}
      >
        <Text.Small
          color={colors.shadesOfBlue.bigStoneDarker}
          transform={'uppercase'}
          weight={600}
        >
          {lead}
        </Text.Small>
      </Layout>

      <Text.Paragraph
        color={colors.shadesOfBlue.bigStoneDarker}
        marginBottom={units(0)}
      >
        <RawHtml.span>
          {description}
        </RawHtml.span>
      </Text.Paragraph>
    </div>
  );
}

/**
 * Export `TeamMember` component.
 */

export default TeamMember;



// WEBPACK FOOTER //
// ../src/client/components/about/team-member.js